export const setRefetch = refetch => ({
  type: 'SET_REFETCH',
  refetch
});
